import { render, staticRenderFns } from "./ProductDetailsV2.vue?vue&type=template&id=2d6df28e&scoped=true&"
import script from "./ProductDetailsV2.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailsV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6df28e",
  null
  
)

export default component.exports